import React from 'react'
import StartupCardTag from './StartupCardTag'

function StartupCard({ startup }) {
    let classnames = 'rounded-[4px] p-2 mx-4 my-4 lg:ml-[24px] lg:w-[313px] shadow-event-card bg-white border-3 border-transparent'

    return (
        <>
            <div className={classnames}>
                <h4 className="mb-3 font-poppins-bold">{startup.attributes.NAM}</h4>
                <p className="text-middle font-open-sans-regular">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <a className="text-sm" target="_blank" rel="noopener noreferrer" href={`https://${startup.attributes.website}`} style={{ hyphens: 'auto',  wordBreak: 'inherit'}}> {startup.attributes.website}</a>
                </p>
                <p className="text-middle font-open-sans-regular">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                    </svg>
                    {startup.attributes.HDQ}
                </p>
                <p className="text-middle font-open-sans-regular">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <a className="text-sm" href={`mailto:${startup.attributes.MAIL_COMPANY}`} style={{ hyphens: 'auto',  wordBreak: 'inherit'}}>{startup.attributes.MAIL_COMPANY}</a>
                </p>
                <div className="flex flex-row flex-wrap">
                    <StartupCardTag title={startup.attributes.LEG?.data.attributes.value} />
                    <StartupCardTag title={startup.attributes.IND?.data.attributes.value} />
                    <StartupCardTag title={startup.attributes.MOD?.data.attributes.value} />
                </div>
            </div>
        </>
    )
}

export default StartupCard
